import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  ServiceMark,
  StatusPill,
} from "@/components/primitives";
import { Icon } from "@/components/Icon";
import { PageHeader } from "@/components/Layout";
import { useSnapshot } from "@/lib/snapshot-context";

export function ServicesAdmin() {
  const navigate = useNavigate();
  const { data } = useSnapshot();
  const services = data.services;
  const rssCount = services.filter((s) => s.source === "rss").length;
  const whCount = services.filter((s) => s.source === "webhook").length;

  return (
    <>
      <PageHeader
        crumbs={["Status Watch", "Admin", "Services"]}
        title="Services"
        subtitle={`${services.length} services monitored · ${rssCount} via RSS · ${whCount} via webhook`}
        actions={
          <>
            <Button variant="outline" icon="download">
              Export config
            </Button>
            <Button
              variant="primary"
              icon="plus"
              onClick={() => navigate("/admin/add")}
            >
              Add service
            </Button>
          </>
        }
      />

      <div style={{ padding: "20px 32px 28px" }}>
        <Card>
          <div
            style={{
              display: "grid",
              gridTemplateColumns:
                "36px 2fr 1.4fr 1.4fr 100px 110px 36px",
              gap: 12,
              padding: "10px 16px",
              fontSize: 11,
              textTransform: "uppercase",
              letterSpacing: "0.04em",
              color: "var(--muted-foreground)",
              background: "var(--muted)",
              fontWeight: 500,
            }}
          >
            <div />
            <div>Service</div>
            <div>Source</div>
            <div>Endpoint</div>
            <div style={{ textAlign: "right" }}>Interval</div>
            <div>Status</div>
            <div />
          </div>
          {services.map((svc, i) => (
            <div
              key={svc.id}
              style={{
                display: "grid",
                gridTemplateColumns:
                  "36px 2fr 1.4fr 1.4fr 100px 110px 36px",
                gap: 12,
                padding: "12px 16px",
                alignItems: "center",
                borderTop: i === 0 ? "none" : "1px solid var(--border)",
              }}
            >
              <ServiceMark service={svc} size={28} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{svc.name}</div>
                <div
                  style={{
                    fontSize: 11,
                    color: "var(--muted-foreground)",
                  }}
                >
                  {svc.domain}
                </div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 5,
                    height: 22,
                    padding: "0 8px",
                    borderRadius: 5,
                    fontSize: 11,
                    fontWeight: 500,
                    background:
                      svc.source === "rss"
                        ? "color-mix(in oklch, var(--color-orange-500) 14%, transparent)"
                        : "color-mix(in oklch, var(--info) 14%, transparent)",
                    color:
                      svc.source === "rss"
                        ? "var(--color-orange-700)"
                        : "var(--info)",
                  }}
                >
                  <Icon
                    name={svc.source === "rss" ? "rss" : "webhook"}
                    size={11}
                  />
                  {svc.source === "rss" ? "RSS feed" : "Webhook"}
                </span>
              </div>
              <code
                style={{
                  fontSize: 11,
                  fontFamily: "var(--font-mono)",
                  color: "var(--muted-foreground)",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {svc.sourceUrl}
              </code>
              <div
                style={{
                  textAlign: "right",
                  fontSize: 12,
                  fontFamily: "var(--font-mono)",
                  color: "var(--muted-foreground)",
                  fontVariantNumeric: "tabular-nums",
                }}
              >
                {svc.pollInterval}
              </div>
              <StatusPill state={svc.state} />
              <button
                type="button"
                onClick={() => navigate(`/services/${svc.id}`)}
                title="View / edit"
                style={{
                  width: 28,
                  height: 28,
                  borderRadius: 6,
                  background: "transparent",
                  border: "1px solid transparent",
                  color: "var(--muted-foreground)",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Icon name="more" size={14} />
              </button>
            </div>
          ))}
        </Card>
      </div>
    </>
  );
}
